import { module, forEach } from "angular";
import { map } from "rxjs/operators";

import type { Observable } from "rxjs";

import type { IResponse, IVideoStream, IVideoStreamSlim } from "App/Modules/Models";
import { AnonymizationLevel, ResolutionMode, VideoStreamFunctions } from "App/Modules/Models";

import type { IHttpService } from "App/Modules/Services";

import type { ISiteVideoStreamsRepository } from "./ISiteVideoStreamsRepository";

export default class SiteVideoStreamsRepository implements ISiteVideoStreamsRepository {
    public static $inject: string[] = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getForSite(siteId: string): Observable<IResponse<IVideoStreamSlim[]>> {
        return this.httpService.get<IVideoStreamSlim[]>(`sites/${siteId}/videoStreams`).pipe(
            map((response) => {
                if (!response.data) {
                    return response;
                }

                forEach(response.data, (videoStream) => {
                    videoStream.images.latest.altText = videoStream.siteEquipmentName;
                    videoStream.images.latest.dtImage = videoStream.dtLastImageUpdate;
                    return videoStream;
                });

                return response;
            }),
        );
    }

    public patchVideoStream(
        siteId: string,
        videoStreamId: string,
        videostream: IVideoStream,
    ): Observable<IResponse<IVideoStream>> {
        if (videostream.anonymizationLevel !== null) {
            videostream.anonymizationLevel = AnonymizationLevel[videostream.anonymizationLevel] as any;
        }

        if (videostream.resolutionMode !== null) {
            videostream.resolutionMode = ResolutionMode[videostream.resolutionMode] as any;
        }

        return this.httpService.patch<IVideoStream>(`sites/${siteId}/videoStreams/${videoStreamId}`, videostream).pipe(
            map((response) => {
                if (!response.data) {
                    return response;
                }

                VideoStreamFunctions.enhanceVideoStream(response.data);

                return response;
            }),
        );
    }

    public deleteVideoStream(siteId: string, videoStreamId: string): Observable<IResponse<void>> {
        return this.httpService.delete(`sites/${siteId}/videoStreams/${videoStreamId}`);
    }

    public isVideoStreamInUse(siteId: string, videoStreamId: string): Observable<IResponse<boolean>> {
        return this.httpService.get<boolean>(`sites/${siteId}/videoStreams/${videoStreamId}/isInUse`);
    }
}

module("mmRepositories").service("mmSiteVideoStreamsRepository", SiteVideoStreamsRepository);
